// SPDX-License-Identifier: LicenseRef-Proprietary

import { useCallback } from 'react';
import { useVaccineDashboardStore } from '../../../store/vaccineDashboardStore';
import { useVaccineClientStore } from '../../../store/vaccineClientStore';

/**
 * Hook to create a scenario from current dashboard state
 * Encapsulates scenario creation logic to eliminate duplication
 */
export function useCreateScenario() {
  const addScenario = useVaccineDashboardStore((state) => state.addScenario);

  return useCallback(() => {
    // Read fresh state from stores at execution time (not from closure)
    // This ensures we always get the latest values, even if debounced updates completed after render
    const dashboardState = useVaccineDashboardStore.getState();
    const inputs = dashboardState.inputs;
    const disease = dashboardState.disease;
    const backendResults = dashboardState.backendResults;
    const treeState = useVaccineClientStore.getState();
    const treeNodes = treeState.nodes;
    const treeEdges = treeState.edges;
    const treeRootId = treeState.rootId;

    const name = `${disease.toUpperCase()} • ${new Date().toLocaleTimeString("fi-FI", { hour: "2-digit", minute: "2-digit" })}`;
    if (!backendResults) {
      console.warn('Cannot create scenario: Model results not available');
      return;
    }

    // Explicitly preserve timeHorizonYears to ensure it's saved correctly
    const scenarioInputs = structuredClone(inputs);
    scenarioInputs.timeHorizonYears = inputs.timeHorizonYears;

    addScenario({
      id: crypto.randomUUID(),
      name,
      audience: "", // Audience removed per user request
      disease,
      inputs: scenarioInputs,
      outputs: structuredClone(backendResults),
      decisionTree: {
        nodes: structuredClone(treeNodes),
        edges: structuredClone(treeEdges),
        rootId: treeRootId
      },
      timestamp: Date.now(),
    });
  }, [addScenario]);
}

